import React, { useEffect } from 'react';
import { Form, useFormikContext, withFormik } from 'formik';
import * as Yup from 'yup';
import { sendFeedbackForm } from './api';
import { TextArea } from '../../OneOffSars/components';
import { Enum } from '../../OneOffSars/components';
import { ErrorList } from '../../OneOffSars/components/ErrorList';
import {useMatomo} from "@datapunt/matomo-tracker-react";

const FeedbackFormSchema = Yup.object().shape({
  feedback: Yup.object().shape({
    satisfaction: Yup.string().required('Select your level of satisfaction'),
    text: Yup.string()
      .max(1200, 'Feedback must be less than 1200 characters')
      .when('satisfaction',{
        is:(value) => value !== 'Very satisfied',
        then:(schema) => schema.required('Feedback text is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
  }),
});

const formikWrapper = withFormik({
  mapPropsToValues: (props) => ({
    ...props.initialValues,
  }),
  validationSchema: FeedbackFormSchema,
  validateOnMount: false,
  validateOnBlur: false,
  validateOnChange: false,
  handleSubmit: (values) => {
    const feedbackData = {
      satisfaction: values.feedback.satisfaction,
      feedback: values.feedback.text,
    };
    sendFeedbackForm(feedbackData)
      .then(() => {
        window.location.href = '/feedback-confirmation';
      })
      .catch(() => {
        window.location.href = '/something-went-wrong';
      });
  },
});

const FeedbackForm = () => {
  const formik = useFormikContext();
  const { trackPageView, trackEvent } = useMatomo();
  useEffect(() => {
    trackPageView({
      documentTitle: 'Feedback - Report Suspicious Chemical Activity '
    });
    trackEvent({
      category: 'Feedback Page',
      action: 'Visited',
    });
  }, []);
  return (
    <div>
      <main
        className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
        id="content"
        role="main"
        tabIndex={0}
      >
        <div className="govuk-grid-row">
          <div className="govuk-grid-column-full">
            <ErrorList />
            <h1 className="govuk-heading-l">Feedback: one-off reporting service</h1>
            <h3 className="govuk-heading-s">
              Overall, how satisfied are you with the process for submitting a report?
            </h3>

            <Form autoComplete="on" onSubmit={formik.handleSubmit}>
              <fieldset className="govuk-fieldset">
                <div className="govuk-grid-column">
                  <Enum
                    enumValues={[
                      { value: 'Very satisfied' },
                      { value: 'Satisfied' },
                      { value: 'Neither satisfied nor dissatisfied' },
                      { value: 'Dissatisfied' },
                      { value: 'Very dissatisfied' },
                    ]}
                    name="feedback.satisfaction"
                    direction="col"
                  />
                </div>
                <div className="govuk-grid-column">
                  <label htmlFor="feedback.text" id="label-feedback.text">
                    <h3 className="govuk-heading-s">
                      How could we improve this service?
                    </h3>
                  </label>
                  <TextArea
                    name="feedback.text"
                    maxChars={1200}
                    data-testid="feedback.text"
                    id="feedback.text"
                  />
                </div>
                <button
                  type="submit"
                  data-prevent-double-click="true"
                  className="govuk-button"
                  data-module="govuk-button"
                  data-test={`button-send-feedback`}
                  aria-label={'Send feedback'}
                >
                  Send feedback
                </button>
              </fieldset>
            </Form>
          </div>
        </div>
      </main>
    </div>
  );
};
const FeedbackFormWithFormik = formikWrapper(FeedbackForm);

export { FeedbackFormWithFormik as FeedbackForm };
